import { render, staticRenderFns } from "./BoxEmail.vue?vue&type=template&id=8d08d950&scoped=true&"
import script from "./BoxEmail.vue?vue&type=script&lang=js&"
export * from "./BoxEmail.vue?vue&type=script&lang=js&"
import style0 from "./BoxEmail.vue?vue&type=style&index=0&id=8d08d950&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d08d950",
  null
  
)

export default component.exports